/**
 * bl-collection.js — collection listing behaviour.
 *
 * Progressive enhancement only. Without this file the facets form is a plain
 * GET form with an Apply button, sorting is a native <select> inside it and
 * pagination is native links — the listing works fully without JavaScript.
 *
 *   facets  auto-submit on change, desktop panel toggle, mobile bottom sheet
 *           with escape handling, scroll lock and focus management.
 */

const BL = window.BrightLeaf;

const MOBILE = '(max-width: 749px)';

BL.components.register('facets', (root) => {
  const toggle = root.querySelector('[data-bl-facets-toggle]');
  const panel = root.querySelector('.bl-facets__panel');
  const scrim = root.querySelector('.bl-facets__scrim');
  const closers = root.querySelectorAll('[data-bl-facets-close]');
  const anchor = root.dataset.blFacetsAnchor || '';

  const isMobile = () => window.matchMedia(MOBILE).matches;

  const submit = () => {
    if (anchor) root.action = root.action.split('#')[0] + anchor;
    // Keep URLs clean: empty range inputs must not become empty query params.
    root.querySelectorAll('input[type="number"]').forEach((input) => {
      if (input.value === '') input.disabled = true;
    });
    root.submit();
  };


  const onChange = (event) => {
    const field = event.target;
    if (!field.name) return;
    if (field.type === 'number') return; // ranges apply on submit / blur
    if (isMobile() && field.type === 'checkbox') return; // mobile applies explicitly
    submit();
  };

  const onKeydown = (event) => {
    if (event.key === 'Enter' && event.target.type === 'number') {
      event.preventDefault();
      submit();
    }
    if (event.key === 'Escape' && root.classList.contains('bl-facets--open')) {
      close();
      toggle?.focus();
    }
  };

  function open() {
    root.classList.add('bl-facets--open');
    toggle?.setAttribute('aria-expanded', 'true');
    if (scrim) scrim.hidden = false;
    if (isMobile()) {
      document.documentElement.classList.add('bl-scroll-locked');
      const first = panel?.querySelector(
        'button, [href], input:not([disabled]), select, summary',
      );
      first?.focus({ preventScroll: true });
    }
  }

  function close() {
    root.classList.remove('bl-facets--open');
    toggle?.setAttribute('aria-expanded', 'false');
    if (scrim) scrim.hidden = true;
    document.documentElement.classList.remove('bl-scroll-locked');
  }

  const onToggle = () => {
    if (root.classList.contains('bl-facets--open')) close();
    else open();
  };

  const onClose = () => {
    close();
    toggle?.focus();
  };

  root.addEventListener('change', onChange);
  root.addEventListener('keydown', onKeydown);
  toggle?.addEventListener('click', onToggle);
  closers.forEach((el) => el.addEventListener('click', onClose));

  if (panel && toggle) root.classList.add('bl-facets--collapsible');

  return () => {
    root.removeEventListener('change', onChange);
    root.removeEventListener('keydown', onKeydown);
    toggle?.removeEventListener('click', onToggle);
    closers.forEach((el) => el.removeEventListener('click', onClose));
    document.documentElement.classList.remove('bl-scroll-locked');
  };
});
